import React, { Component } from 'react';
import { Grid, Button } from 'semantic-ui-react';
import { withRouter } from "react-router-dom";
import { Link } from 'react-router-dom';

import 'semantic-ui-css/semantic.min.css';
import Field from "../../components/forms/field";
import FormattedDate from "../../components/formatters/formattedDate";
import * as api from "../../api";
import * as qs from "query-string";

import {AuthService} from "../../services/auth-service";

class MeterTab extends Component {

    constructor(props) {
        super(props);
        this.authServices = new AuthService();

        this.state = {
            meterDetail: {},
            isLoaded: false,
            params: qs.parse(this.props.location.search)
        };

        this.fetchData();
    }

    fetchData = () => {
        api.getMeterDetail(this.props.customerId, this.props.meter.siteKey, this.props.meter.meterSiteKey)
            .then(meterDetail => {
                if(!meterDetail) { return; }
                this.setState({meterDetail: meterDetail, isLoaded: true});
            });
    }

    

    render() {
        return (
            <Grid padded stackable columns='equal' verticalAlign='top'>
                {this.state.isLoaded &&
                  <Grid.Row>
                      <Grid.Column>
                          <Field label={"Meter Reference"} value={this.state.meterDetail.meterReference}/>
                          <Field label={"Serial Number"} value={this.state.meterDetail.serialNumber}/>
                          {this.state.meterDetail.latestRead && <Field label={"Latest Read"} value={this.state.meterDetail.latestRead}/> }
                          {this.state.meterDetail.lastReadDate && <Field label={"Last Read Date"} value={<FormattedDate value={this.state.meterDetail.lastReadDate} inputFormat="DD/MM/YYYY"/>}/>  }
                      </Grid.Column>
                      <Grid.Column>
                          <Field label={"Supplier"} value={this.state.meterDetail.supplier}/>
                          {this.state.meterDetail.contractEndDate && <Field label={"Contract End Date"} value={<FormattedDate value={this.state.meterDetail.contractEndDate} inputFormat="DD/MM/YYYY"/>}/>}
                           {this.state.meterDetail.lastActualRead && <Field label={"Last Actual Read"} value={<FormattedDate value={this.state.meterDetail.lastActualRead} inputFormat="DD/MM/YYYY"/>}/>}
                           <Field label={"Supply Address"} value={this.state.meterDetail.supplyAddress}/>
                           <Field label={"Connection Type"} value={
                             this.state.meterDetail.connectionType === "IMP" ? "Import" : 
                             (this.state.meterDetail.connectionType === "EXP" ? "Export" :
                             (this.state.meterDetail.connectionType === "GEN" ? "Generation" : "")
                             )
                            
                            }/>

                      </Grid.Column>
              </Grid.Row>}
              {this.state.params.meterReadMode === undefined &&
              <Grid.Column>
                   {((this.authServices.getCotsStatus() !== 'none')) &&

                <div>
                   <Link to={"site?siteKey="+ this.props.meter.siteKey+"&removeMeterKey=" + this.props.meter.meterSiteKey}>
                                            

                    
                <Button   floated='right' id='rem-meters'>Request Meter Removal</Button>
                </Link>
              
                <Link to={"site?siteKey="+ this.props.meter.siteKey+"&updateMeterKey=" + this.props.meter.meterSiteKey}>
                                            

                <Button  floated='right' id='upd-meters' >Request Meter Update</Button>
                </Link>

                </div>
                
    }
                </Grid.Column>
    }
          </Grid>
        );
    }

}

export default withRouter(MeterTab)